import { REDUCER } from '../reducers/reducersConst';

let initialState = {
  description: 'errorPage.description.notFound',
  code: '404'
};

export let error = (state = initialState, action) => {
  switch (action.type) {
    case REDUCER.ERROR.SET_CODE:
      return {
        ...state,
        code: action.code
      };
    case REDUCER.ERROR.SET_DESCRIPTION:
      return {
        ...state,
        description: action.description
      };
    default:
      return state;
  }
};
